import { createContext } from 'react'

export enum EditModeContent {
    BODY = 'BODY',
    PDF = 'PDF',
    SPREADSHEET = 'SPREADSHEET',
    PREVIEW = 'PREVIEW'
}

export function strToEditModeContent(str: string): EditModeContent {
    const result = EditModeContent[str]
    
    if (!result) {
        return EditModeContent.PREVIEW
    }
    return result
}

export const ReportContentCtx = createContext<{
    editModeContent: EditModeContent
    setEditModeContent: (mode: EditModeContent) => void
}>({
    editModeContent: EditModeContent.PREVIEW,
    setEditModeContent: () => {}
})

export function decoratorEditModeContent(history: any) {
    return function setEditModeContent(mode: EditModeContent) {
        return history.push({
            search: `?${new URLSearchParams({
                editModeContent: String(mode)
            })}`
        })
    }
}
